export const homeObjOne = {
    id: 'about',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: 'Valgraen',
    headline: 'O mně',
    description: 'Vítej u mě! Můžeš zde čekat PlayStation streamy z různých příběhovek na střední/vysoké obtížnosti, občasný multiplayer s diváky a velkou interakci s chatem. Budu rád, když se do naší komunity přidáš, každý nový příchozí je vítán s otevřenou náručí 💖💋',
    buttonLabel: 'Get Started!',
    imgStart: true,
    img: require('../../images/logo.png'),
    alt: 'Itachi',
    dark: true,
    primary: true,
    darkText: false
}